import * as React from "react";
import { Table } from "antdv5";
import type { ColumnsType } from "antdv5/es/table";
import { Link } from "react-router-dom";
import { color } from "../../../styles/color";
import { Obj } from "../../../client_types";
import { context } from "../../context/Context";

interface DataType {
  PlaceName: string;
  PlaceDistance: string;
  StringDate: string;
  Status: string;
  MatchGameName: string;
}
interface GameData {
  data: DataType[];
  loading: boolean;
  totalPage: number | null;
}
interface IProps {
  type: "match" | "train";
  gameSet: GameData;
  trainSet: GameData;
}
const MatchPageTable = ({ type, gameSet, trainSet }: IProps) => {
  const { dispatch } = React.useContext(context);
  const columns: ColumnsType<DataType> = [
    {
      title: "比赛名称",
      dataIndex: "MatchGameName",
      ellipsis: true,
      width: 75,
      render: (text: string, i: Obj) => (
        <Link
          to={`/racelive/${i.MatchID}/${i.MatchGameID}/${i.MatchGameType}`}
          style={{ color: `${color.markedSecondary}` }}
          onClick={() => {
            dispatch({ gameType: i.MatchGameType, gameid: i.MatchGameID });
            localStorage.setItem("gameName", i.MatchGameName);
          }}
        >
          {text}
        </Link>
      ),
    },
    {
      title: "司放地",
      width: 60,
      dataIndex: "PlaceName",
      onCell: () => ({
        style: {
          minWidth: 80,
        },
      }),
    },
    {
      title: "参考空距(M)",
      dataIndex: "PlaceDistance",
      width: 100,
      onCell: () => ({
        style: {
          minWidth: 110,
        },
      }),
    },
    {
      title: "司放时间",
      width: 120,
      dataIndex: "StringDate",
      onCell: () => ({
        style: {
          minWidth: 200,
        },
      }),
    },
    {
      title: "状态",
      dataIndex: "Status",
      width: 70,
    },
  ];

  const pagination = {
    pageSizeOptions: ["20", "50", "100"],
    defaultPageSize: 20,
    total: (type === "match" ? gameSet.totalPage : trainSet.totalPage) || 0,
    showTotal: (total: number, range: [number, number]) =>
      `${range[0]}-${range[1]} of ${total} 条`,
    showQuickJumper: true,
    responsive: true,
  };
  const scroll = { y: undefined, x: 750 };
  const rowKey = "MatchGameID";
  const size = "small";

  return type === "match" ? (
    <Table
      className="MatchPageTable"
      columns={columns}
      dataSource={gameSet.data}
      loading={gameSet.loading}
      pagination={pagination}
      scroll={scroll}
      rowKey={rowKey}
      size={size}
    />
  ) : (
    <Table
      className="MatchPageTable"
      columns={columns}
      dataSource={trainSet.data}
      loading={trainSet.loading}
      pagination={pagination}
      scroll={scroll}
      rowKey={rowKey}
      size={size}
    />
  );
};

export default MatchPageTable;
